module.exports = __webpack_public_path__ + "img/07.465dd526.jpg";